import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppointmentService } from 'src/app/services/appointment.service';
import { BackgroundFormService } from 'src/app/services/background-form.service';
import { DatePipe } from '@angular/common';
import SignaturePad from 'signature_pad';

export const ADULT_AGE_THRESHOLD = 18;

declare var jQuery: any;

@Component({
  selector: 'app-background-form',
  templateUrl: './background-form.component.html',
  styleUrls: ['./background-form.component.scss']
})
export class BackgroundFormComponent implements OnInit {
  concernForm!: FormGroup
  answersForm!: FormGroup
  backgroundDetails: any = {};
  answers: any
  isReadOnly: boolean = true
  token: any
  clientDetails: any = []
  clientInfo: any;
  clientId: any
  appointmentId: any
  invalidToken: boolean = false
  disableFormButton=false;
  
  isMinor: boolean = false;
  currentDate = new Date();
  
  @ViewChild('signatureCanvas') signatureCanvas!: ElementRef<HTMLCanvasElement>;
  signaturePad!: SignaturePad;

  constructor(private spinner: NgxSpinnerService,
    private backgroundFormService: BackgroundFormService,
    private appointmentService: AppointmentService,
    private formBuilder: FormBuilder, private activatedRoute: ActivatedRoute,
    private datePipe: DatePipe) {
    this.concernForm = this.formBuilder.group({
      concentrate: ['', Validators.required],
      distractions: ['', Validators.required],
      attention: ['', Validators.required],
      thinkBeforeAct: ['', Validators.required],
      waitForTurn: ['', Validators.required],
      startWithoutAsked: ['', Validators.required],
      completeTask: ['', Validators.required],
      organised: ['', Validators.required],
      trackOfTime: ['', Validators.required],
      rememberInstructions: ['', Validators.required],
      rememberRead: ['', Validators.required],
      controlEmotions: ['', Validators.required],
    });


    this.answersForm = this.formBuilder.group({
      interestInEval: ['', Validators.required],
      howIssuesImpacted: ['', Validators.required],
      learnFromAssesment: ['', Validators.required],
      medicalConditions: ['', Validators.required],
      performanceInSchool: ['', Validators.required],
      easySubjects: ['', Validators.required],
      challengingSubjects: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.spinner.show()
    this.token = this.activatedRoute.snapshot.queryParamMap.get('token');
    this.backgroundFormService.validateTokenbackgroundForm(this.token).subscribe(res => {
      this.clientDetails = res;
      this.clientInfo = this.clientDetails.data
      this.clientId = this.clientInfo.clientId
      this.appointmentId = this.clientInfo.appointmentId
      if (this.clientDetails.data.result == "Does not exists!!!") {
        this.invalidToken = true
      }
      this.spinner.hide()

    })
    let emailPattern = /^\s*([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})?\s*$/;
    this.answersForm = this.formBuilder.group({
      answer1: [''],
      answer2: ['', Validators.required],
      answer3: [''],
      answer4: ['', Validators.required],
      answer5: [''],
      answer6: ['', Validators.required],
      answer7: [''],
      answer8: ['', Validators.required],
      answer9: ['', Validators.required],
      answer10: [''],
      answer11: ['', Validators.required],
      answer12: [''],
      answer13: ['', Validators.required],
      answer14: ['', Validators.required],
      answer15: ['', Validators.required],
      answer16: ['', Validators.required],
      answer17: ['', Validators.required],
      answer18: ['', Validators.required],
      answer19: ['', Validators.required],
      answer20: ['', Validators.required],
      answer21: ['', Validators.required],
      answer22: ['', Validators.required],
      answer23: ['', Validators.required],
      answer24: ['', Validators.required],
      answer25: [''],
      answer26: ['', [Validators.pattern(emailPattern)]],
      answer27: ['', Validators.required],
      answer28: [''],
      dateOfBirth: ['', Validators.required],
      currentSchool: ['', Validators.required],
      backgroundFormComment: ['', Validators.required],
      concentrateWhenReading: ['', Validators.required],
      avoidDistractions: ['', Validators.required],
      payAttentionInBoringClass: ['', Validators.required],
      thinkBeforeAct: ['', Validators.required],
      waitForTurn: ['', Validators.required],
      startWithoutAsked: ['', Validators.required],
      completeTask: ['', Validators.required],
      stayOrganised: ['', Validators.required],
      keepTrackOfTime: ['', Validators.required],
      rememberInstructions: ['', Validators.required],
      rememberRead: ['', Validators.required],
      controlEmotions: ['', Validators.required],
      
      submitterName: ['', Validators.required],
      guardians: this.formBuilder.array([]),
      consentConfirmation: [false],
      signatureData: ['']
    });

    this.answersForm.get('dateOfBirth')?.valueChanges.subscribe(dob => {
      this.checkAge(dob);
    });
  }


  checkAge(dobStr: string | Date) {
    if (!dobStr) {
      this.isMinor = false;
      return;
    }
    const dob = new Date(dobStr);
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const m = today.getMonth() - dob.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
      age--;
    }
    
    const wasMinor = this.isMinor;
    this.isMinor = age < ADULT_AGE_THRESHOLD;

    if (this.isMinor && !wasMinor) {
      // Setup minor fields
      if (this.guardians.length === 0) {
        this.addGuardian();
      }
      this.answersForm.get('consentConfirmation')?.setValidators([Validators.requiredTrue]);
      this.answersForm.get('signatureData')?.setValidators([Validators.required]);
      
      // Initialize signature pad after view updates
      setTimeout(() => {
        if (this.signatureCanvas) {
          const canvas = this.signatureCanvas.nativeElement;
          
          // Set internal canvas dimensions to match CSS dimensions
          const rect = canvas.getBoundingClientRect();
          canvas.width = rect.width || 500;
          canvas.height = rect.height || 200;
          
          this.signaturePad = new SignaturePad(canvas, {
            penColor: "rgb(0, 0, 0)",
            backgroundColor: "rgb(255, 255, 255)"
          });
          
          this.signaturePad.onEnd = () => {
             this.answersForm.patchValue({ signatureData: this.signaturePad.toDataURL() });
          };
          
          // Clear to initialize background
          this.signaturePad.clear();
        }
      }, 200);
    } else if (!this.isMinor) {
      this.answersForm.get('consentConfirmation')?.clearValidators();
      this.answersForm.get('signatureData')?.clearValidators();
      while (this.guardians.length !== 0) {
        this.guardians.removeAt(0);
      }
    }
    
    this.answersForm.get('consentConfirmation')?.updateValueAndValidity();
    this.answersForm.get('signatureData')?.updateValueAndValidity();
  }

  get guardians() {
    return this.answersForm.get('guardians') as FormArray;
  }

  addGuardian() {
    const guardianGroup = this.formBuilder.group({
      name: ['', Validators.required],
      relationship: ['', Validators.required],
      isAware: [null, Validators.required]
    });
    this.guardians.push(guardianGroup);
  }

  removeGuardian(index: number) {
    if (this.guardians.length > 1) {
      this.guardians.removeAt(index);
    }
  }

  clearSignature() {
    if (this.signaturePad) {
      this.signaturePad.clear();
      this.answersForm.patchValue({ signatureData: '' });
    }
  }

  submit() {
    this.disableFormButton=true;

    const formattedDOB = this.datePipe.transform(this.answersForm.value.dateOfBirth, 'MM/dd/yyyy');

    this.backgroundDetails['clientId'] = this.clientId;
    this.backgroundDetails['appointmentId'] = this.appointmentId
    this.backgroundDetails['backgroundDetails'] = this.answersForm.value
    this.backgroundDetails['token'] = this.token,
    this.backgroundDetails['strDOB'] =formattedDOB 
    this.spinner.show()
    this.backgroundFormService.submitBackgroundFormDetails(this.backgroundDetails).subscribe((res: any) => {
      if (res.code == '500') {
        jQuery('#errorModal').modal('show');
        this.spinner.hide();
        return;
      }
      this.spinner.hide()
      location.reload();
    },
      (err) => {
        jQuery('#errorModal').modal('show');
        this.spinner.hide();
        return;

      })

  }

  closeWindow() {
    window.close();
  }





}
